import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { ConfigurazioneHome } from '../../../shared/interface';

@Component({
  selector: 'app-home-evidenza-backoffice',
  templateUrl: './home-evidenza-backoffice.component.html',
  styleUrl: './home-evidenza-backoffice.component.css'
})
export class HomeEvidenzaBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private router: Router) { }

  configurazione?: ConfigurazioneHome;

  tipi = [
    { label: 'Video', value: 'video' },
    { label: 'Immagine', value: 'immagine' },
  ];

  tipiPulsante = [
    { label: 'Apri un link', value: 'link' },
    { label: 'Scarica un file', value: 'file' },
  ];

  formHome!: FormGroup;

  ngOnInit(): void {
    this.formHome = new FormGroup({
      attivo: new FormControl(false),
      tipo: new FormControl('video', Validators.required),
      video: new FormControl(null),
      immagine: new FormControl(null),
      testo: new FormControl(null),
      link: new FormControl(null),
      testo_link: new FormControl(null),
      tipo_pulsante: new FormControl('link', Validators.required),
      file: new FormControl(null),
    });

    this.apiService.getConfigurazioneHome().subscribe({
      next: (data) => this.configurazione = data,
      error: () => this.configurazione = undefined,
      complete: () => this.patchForm(),
    });
  }

  get isVideo(): boolean {
    return this.formHome.get('tipo')?.value === 'video';
  }

  get isImmagine(): boolean {
    return this.formHome.get('tipo')?.value === 'immagine';
  }

  get isAttivo(): boolean {
    return !!this.formHome.get('attivo')?.value?.length;
  }

  get isPulsanteLink(): boolean {
    return this.formHome.get('tipo_pulsante')?.value === 'link';
  }

  get isPulsanteFile(): boolean {
    return this.formHome.get('tipo_pulsante')?.value === 'file';
  }

  /** Nome file già salvato (stringa), non un File appena selezionato. */
  storedName(v: unknown): string {
    if (typeof v === 'string' && v.trim()) return v.trim();
    return '';
  }

  private patchForm(): void {
    if (!this.configurazione?.id) {
      return;
    }

    this.formHome.patchValue({
      attivo: this.configurazione.attivo ? ['attivo'] : [],
      tipo: this.configurazione.tipo || 'video',
      video: this.configurazione.video,
      immagine: this.configurazione.immagine,
      testo: this.configurazione.testo,
      link: this.configurazione.link,
      testo_link: this.configurazione.testo_link,
      tipo_pulsante: this.configurazione.tipo_pulsante || 'link',
      file: this.configurazione.file,
    });
  }

  onSubmit(): void {
    const home = new FormData();
    const attivo = this.formHome.get('attivo')?.value?.length > 0;

    home.append('attivo', attivo ? 'true' : 'false');
    home.append('tipo', this.formHome.get('tipo')?.value || 'video');
    home.append('video', this.formHome.get('video')?.value || '');
    home.append('immagine', this.formHome.get('immagine')?.value || '');
    home.append('testo', this.formHome.get('testo')?.value || '');
    home.append('link', this.formHome.get('link')?.value || '');
    home.append('testo_link', this.formHome.get('testo_link')?.value || '');
    home.append('tipo_pulsante', this.formHome.get('tipo_pulsante')?.value || 'link');
    home.append('file', this.formHome.get('file')?.value || '');

    const request = this.configurazione?.id
      ? this.apiService.updateConfigurazioneHome(home)
      : this.apiService.addConfigurazioneHome(home);

    request.subscribe({
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.apiService.message('success', 'Successo', 'Evidenza home salvata con successo!');
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/backoffice/home-evidenza']);
        });
      },
    });
  }
}
